import { FORECAST_STATUS } from "@/components/forecasts/constants";
import ItemValidator from "@/components/forecasts/validation/itemValidator";

// These rules mirror some of the back end rules defined in \Rem3rch\ForecastBundle\Validator\ForecastValidator
export default class ForecastValidator {
    static canUpdate(forecast) {
        return !forecast.deleted && !forecast.isTransmissionApproved;
    }

    static canUpdateCampaign(forecast) {
        if (!this.canUpdate(forecast)) {
            return false;
        }

        return forecast.status === FORECAST_STATUS.DRAFT;
    }

    static canDelete(forecast) {
        return !forecast.deleted && !forecast.isTransmissionApproved;
    }

    static canDuplicate(forecast) {
        // as of now every forecast can be duplicated
        return true;
    }

    static canReChallenge(forecast) {
        return this.canUpdate(forecast) && forecast.status === FORECAST_STATUS.ACTIVE;
    }

    static canModifyItems(forecast) {
        if (!this.canUpdate(forecast)) {
            return false;
        }
        return forecast.status !== FORECAST_STATUS.CLOSED;
    }

    static canAddItem(forecast, forecastItems, item) {
        let itemAlreadyInForecast = forecastItems.find(i => i.id === item.id);
        if (itemAlreadyInForecast) {
            return false;
        }
        if (ItemValidator.isDisabled(item)) {
            return false;
        }
        if (!this.canUpdate(forecast)) {
            return false;
        }

        if (!this.canModifyItems(forecast)) {
            return false;
        }

        if (forecast.status === FORECAST_STATUS.DRAFT) {
            return true;
        }
        return this.hasItemPriceForAllZones(item, forecast.zones);
    }

    static canRemoveItem(forecast, item) {
        if (forecast.status === FORECAST_STATUS.PENDING || forecast.status === FORECAST_STATUS.ACTIVE) {
            // Published forecast have to have at least one item
            if (forecast.numberOfItems <= 1) {
                return false;
            }
        }
        return this.canUpdate(forecast);
    }

    static containsItemsWithoutPrice(forecast) {
        for (const item of forecast.items) {
            if (!this.hasItemPriceForAllZones(item, forecast.zones)) {
                return true;
            }
        }
        return false;
    }

    static hasItemPriceForAllZones(item, zones) {
        for (const zone of zones) {
            if (!this.hasItemPriceForZone(item, zone)) {
                return false;
            }
        }

        return true;
    }

    static hasItemPriceForZone(item, zone) {
        return this.getItemPriceForZone(item, zone).value !== "";
    }

    static getItemPriceForZone(item, zone) {
        let noPrice = { value: "", currency: "" };
        if (!item.hasOwnProperty("prices")) {
            return noPrice;
        }
        let price = item.prices.find(price => price.zone.id === zone.id);
        return price && price.value !== 0 ? { value: price.value, currency: price.currency.shortName } : noPrice;
    }
}

export function canAddItemToAtLeastOneForecast(forecasts, forecastItems, item) {
    // temporarily disabled for performance improvements
    // @todo: re-activate
    return true;
    // return forecasts.some(forecast => ForecastValidator.canAddItem(forecast, forecastItems, item));
}



// WEBPACK FOOTER //
// ./src/components/forecasts/validation/forecastValidator.js